import React, { FC, useMemo } from 'react';
import TableCell from 'src/components/TableCell';
import { Box, TableCellProps } from '@material-ui/core';
import { MdArrowDownward as DownIcon } from '@react-icons/all-files/md/MdArrowDownward';
import { MdArrowUpward as UpIcon } from '@react-icons/all-files/md/MdArrowUpward';

interface Props extends TableCellProps {
  name: string;
  sortDirection?: 'asc' | 'desc';
  onClick?: () => void;
}

const DealHeaderTableCell: FC<Props> = ({ onClick, sortDirection, name, ...props }) => {
  const sortIcon = useMemo(() => {
    if (!sortDirection) {
      return null;
    }

    if (sortDirection === 'asc') {
      return (
        <Box ml={1} clone>
          <UpIcon color='disabled' />
        </Box>
      );
    } else {
      return (
        <Box ml={1} clone>
          <DownIcon color='disabled' />
        </Box>
      );
    }
  }, [sortDirection]);

  return (
    <TableCell style={{ cursor: 'pointer' }} onClick={onClick} {...props}>
      <Box alignItems='center' display='flex'>
        <div>{name}</div>
        {sortIcon}
      </Box>
    </TableCell>
  );
};

export default DealHeaderTableCell;
